export default __webpack_public_path__ + "static/event-storytelling-6e585303f0ef91f4b0fafcc197ae0fbe.jpg";